import {api} from './api';
import {ApiResponse, PageResponse} from '../types/announcement';
import type {VersionRecord, VersionRecordReq} from '../types/version';

/**
 * 版本记录接口：管理端增删查改需 PAGE_VERSION_MGMT/ADMIN；当前版本读取对所有登录用户开放
 */
export const versionService = {
    /** 版本列表（管理页，更新日期倒序） */
    list: async (page: number = 0, size: number = 20): Promise<PageResponse<VersionRecord>> => {
        const response = await api.get<ApiResponse<PageResponse<VersionRecord>>>(
            `/api/v1/system/versions?page=${page}&size=${size}`
        );
        if (response.data.success && response.data.data) {
            return response.data.data;
        }
        return {content: [], totalElements: 0, totalPages: 0, number: page, size};
    },

    /** 当前版本（交易界面展示）；未设置时后端返回 data=null */
    getCurrent: async (): Promise<VersionRecord | null> => {
        const response = await api.get<ApiResponse<VersionRecord>>('/api/v1/system/versions/current');
        return response.data.success ? (response.data.data ?? null) : null;
    },

    /** 新增；后端业务失败（如版本号重复）抛出后端提示文案 */
    create: async (payload: VersionRecordReq): Promise<VersionRecord | null> => {
        const response = await api.post<ApiResponse<VersionRecord>>('/api/v1/system/versions', payload);
        if (!response.data.success) {
            throw new Error(response.data.message ?? '新增版本失败');
        }
        return response.data.data ?? null;
    },

    /** 修改；同样把后端提示透出给页面 */
    update: async (id: number, payload: VersionRecordReq): Promise<VersionRecord | null> => {
        const response = await api.put<ApiResponse<VersionRecord>>(`/api/v1/system/versions/${id}`, payload);
        if (!response.data.success) {
            throw new Error(response.data.message ?? '修改版本失败');
        }
        return response.data.data ?? null;
    },

    /** 删除（软删） */
    remove: async (id: number): Promise<void> => {
        const response = await api.delete<ApiResponse<void>>(`/api/v1/system/versions/${id}`);
        if (!response.data.success) {
            throw new Error(response.data.message ?? '删除版本失败');
        }
    },
};
